import { Button, EditHollowSVG, ExternalLinkSVG, Icon } from "@newsela/angelou";

import { withTrackEvent } from "@newsela/snitch";
import {
  buttonCss,
  buttonLabelCss,
  editIconCss,
  externalLinkIconCss,
} from "./FormativeOption.style";

interface FormativeOptionProps {
  contentId: string;
  ctaText: string;
  data: {
    url: string;
    payload: string;
  };
  modalTriggerRef?: { current: null };
  onModalOpen?: () => void;
}

const ButtonWithTrackEvent = withTrackEvent(
  Button,
) as React.ForwardRefExoticComponent<
  React.ComponentProps<typeof Button> & React.RefAttributes<HTMLButtonElement>
>;

const FORMATIVE_CTA = "Customize this article's activities";

const FormativeOption = ({
  contentId,
  ctaText,
  data,
  modalTriggerRef,
  onModalOpen,
}: FormativeOptionProps) => {
  const eventProperties = {
    objectType: "User",
    actionName: "Navigate",
    streamProperties: {
      description: FORMATIVE_CTA,
      content_id: contentId,
    },
  };

  const renderFormativeButton = () => {
    return (
      <ButtonWithTrackEvent
        __cssFor={{ root: buttonCss, Icon: { root: externalLinkIconCss } }}
        ariaProps={{
          "aria-label": `${ctaText}. Opens in new tab`,
        }}
        dataProps={{ "data-qa-selector": "formative-activity-panel-link" }}
        icon={{
          SvgComponent: ExternalLinkSVG,
          alignment: Button.iconAlignments.right,
        }}
        flavor={Button.flavors.polarMuted}
        isFullWidth
        type="submit"
        ref={modalTriggerRef}
        {...(onModalOpen && { onClick: onModalOpen })}
        {...eventProperties}
      >
        <div css={buttonLabelCss}>
          <Icon
            __cssFor={{ root: editIconCss }}
            SvgComponent={EditHollowSVG}
            size={Icon.sizes.sm}
          />
          {ctaText}
        </div>
      </ButtonWithTrackEvent>
    );
  };

  return onModalOpen ? (
    renderFormativeButton()
  ) : (
    <form method="post" action={data.url} target="_blank">
      <input name="id_token" type="hidden" value={data.payload} />
      {renderFormativeButton()}
    </form>
  );
};

export default FormativeOption;
